import React from 'react';
export function AshleyIntro() {
  return <section id="ashley" className="px-6 md:px-12 lg:px-20 max-w-[88rem] mx-auto py-28 md:py-36 border-t border-ink/10" data-id="element-11" data-mp="26d0l3j3uc7gx">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8 items-start" data-id="element-12" data-mp="2loghge9hgfgz">
        <div className="md:col-span-3 md:col-start-2 max-w-[15rem] md:max-w-none" data-id="element-13" data-mp="2gpm1dk2wh50k">
          <img src="https://cdn.magicpatterns.com/uploads/8Y1TEGfBX9aomTBcah5jvA/AshGarica_Headshot_copy.jpg" alt="Portrait of Ashley Garcia standing at an oceanfront railing" className="aspect-[3/4] w-full object-cover object-top bg-ink/5" data-id="element-14" data-mp="2grq1rs1lblw3" />
        </div>
        <div className="md:col-span-6 md:col-start-6 md:pt-2" data-id="element-15" data-mp="22w4epqex3c6b">
          <div className="label text-graphite/60 mb-8" data-id="element-16" data-mp="1y0fdlin91n7w">The Coach</div>
          <h2 className="text-4xl md:text-5xl mb-10" data-id="element-17" data-mp="1t0kmbdzkavmb">Ashley Garcia</h2>
          <p className="font-sans font-light text-lg text-graphite/80 leading-relaxed max-w-xl" data-id="element-18" data-mp="1t1vqhewx65dy">
            Board-certified health and wellness coach and IFBB professional
            athlete, with sixteen years in the work. She has coached
            executives, competitors, and frequent travelers through every
            season of training. Every Vera system is built on her method and
            held to her standard.
          </p>
        </div>
      </div>
    </section>;
}